export default __webpack_public_path__ + "bd5bf729bc23b88b5f76eb6fcc5c03cc.png";